module.exports = __webpack_public_path__ + "img/y23.583ef143.jpg";